/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Layout,
  Card,
  Table,
  Button,
  Spin,
  Row,
  Col,
  Descriptions,
} from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import { postAPI, displayMessage } from "../../utils/common";
import { ERROR_MSG_TYPE } from "../../constants/messages";
import { KITCHEN_PURCHASE_DETAIL } from "../../constants/api";

function KitchenPurchaseView() {
  const { Content } = Layout;
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [purchase, setPurchase] = useState(null);

  useLayoutEffect(() => {
    getDetail();
  }, []);

  const getDetail = () => {
    setLoading(true);

    postAPI(
      KITCHEN_PURCHASE_DETAIL,
      { id },
      (res) => {
        if (res.status === true) {
          setPurchase(res.data);
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
        setLoading(false);
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to get purchase detail");
      },
    );
  };

  const columns = [
    {
      title: "S.No",
      render: (_, __, index) => index + 1,
      width: 60,
    },
    {
      title: "Item Code",
      dataIndex: ["item", "item_code"],
      width: 100,
    },
    {
      title: "Item Name",
      dataIndex: ["item", "name"],
      width: 100,
    },
    {
      title: "Purchased",
      dataIndex: "qty",
      width: 100,
      render: (v) => parseFloat(v),
    },
    {
      title: "Returned",
      dataIndex: "returned_qty",
      width: 100,
      render: (v) => parseFloat(v),
    },
    {
      title: "Remaining",
      dataIndex: "remaining_qty",
      width: 100,
      render: (v) => parseFloat(v),
    },
    {
      title: "Rate",
      dataIndex: "rate",
      width: 120,
      render: (v) => `₹ ${v}`,
    },
    {
      title: "Remaining Amount",
      dataIndex: "amount",
      width: 150,
      render: (v, row) =>
        `₹ ${parseFloat(row.rate * row.remaining_qty).toFixed(2)}`,
    },
    {
      title: "Purchased Amount",
      dataIndex: "amount",
      width: 150,
      render: (v) => `₹ ${v}`,
    },
    {
      title: "Expiry Date",
      dataIndex: "item_expiry_date",
      width: 150,
      render: (v) => dayjs(v).format("DD MMM YYYY"),
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Purchase Detail"
          bordered={false}
          extra={
            <Button type="primary" ghost onClick={() => navigate(-1)}>
              <RollbackOutlined />
            </Button>
          }
        >
          <Spin spinning={loading}>
            {purchase && (
              <>
                {/* Purchase Summary */}
                <Descriptions bordered size="small" column={2}>
                  <Descriptions.Item label="Purchase Date">
                    {dayjs(purchase.purchase_date).format("DD MMM YYYY")}
                  </Descriptions.Item>

                  <Descriptions.Item label="Supplier">
                    {purchase.supplier_name}
                  </Descriptions.Item>

                  <Descriptions.Item label="Total Amount">
                    ₹ {purchase.total_amount}
                  </Descriptions.Item>

                  <Descriptions.Item label="Remark">
                    {purchase.remark || "-"}
                  </Descriptions.Item>
                </Descriptions>

                {/* Items Table */}
                <Row style={{ marginTop: 20 }}>
                  <Col span={24}>
                    <Table
                      columns={columns}
                      dataSource={purchase.items}
                      pagination={false}
                      rowKey={(row, index) => index}
                    />
                  </Col>
                </Row>
              </>
            )}
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default KitchenPurchaseView;
